import { __assign, __extends, __spreadArrays } from "tslib";
import { namespacedClassnames } from '../../../common/namespace-classes';
import * as React from 'react';
import { ReactSelectCreatable, ReactSelectAsync, ReactSelect3, ReactSelect3Components } from '../../../common/react-select';
import { LibColor, Text } from '../../../new-libby';
import { selectV3Styles } from '../select-v3-styles';
import { getChevronIcon } from '../chevron-icon';
import { Icon } from '../../icon/icon';
import { iconsMap } from '../../../icons';
import { useOnScroll } from '../../../common/hooks';
import { isFeatureEnabled } from '@wix/answers-experiments';
var V3Menu = function (menuProps) {
    var _a = useOnScroll(), scrolled = _a[0], onScroll = _a[1];
    return (React.createElement(ReactSelect3Components.Menu, __assign({}, menuProps),
        React.createElement("div", { className: namespacedClassnames({ scrolled: scrolled }), onScroll: onScroll }, menuProps.children)));
};
/** @deprecated use <MultiSelect/> */
var DeprecatedMultiSelect = /** @class */ (function (_super) {
    __extends(DeprecatedMultiSelect, _super);
    function DeprecatedMultiSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createOptions = function () {
            var _a = _this.props, selectedOptions = _a.selectedOptions, options = _a.options;
            if (selectedOptions) {
                var maybeDuplicates_1 = __spreadArrays(selectedOptions, options);
                return maybeDuplicates_1.filter(function (selectOption, idx) {
                    return maybeDuplicates_1.findIndex(function (obj) { return obj.value === selectOption.value; }) === idx;
                });
            }
            else {
                return options;
            }
        };
        _this.setCreatableSelectElem = function (elem) {
            _this.reactSelectElem = elem;
        };
        _this.fakeLoadOptions = function (_, cb) {
            cb(null, { options: _this.createOptions() });
        };
        _this.clearInput = function () {
            setTimeout(function () {
                if (_this.reactSelectElem && _this.reactSelectElem.select) {
                    _this.reactSelectElem.select.setState({ inputValue: _this.reactSelectElem.select.handleInputValueChange('') });
                }
            }, 10);
        };
        _this.onCreateNewOption = function (obj) {
            var newOptions = __spreadArrays((_this.props.value || []), [obj]);
            _this.onChange(newOptions);
        };
        _this.onChange = function (options) {
            _this.props.onChange(options);
            _this.clearInput();
        };
        _this.isValidNewOption = function (option) {
            return _this.props.newOptionValidator ? _this.props.newOptionValidator(option.label) : !!option.label;
        };
        _this.promptTextCreator = function (label) {
            return (_this.props.createOptionPlaceholder || 'Create option') + ": \"" + label + "\"";
        };
        _this.onInputChange = function (term) {
            if (_this.props.onInputChange) {
                _this.props.onInputChange(term);
            }
        };
        _this.formatOptionLabel = function (data, context) {
            if (context.context === 'menu') {
                return _this.props.optionRenderer ? _this.props.optionRenderer(data) : data.label;
            }
            else {
                return _this.props.valueRenderer ? _this.props.valueRenderer(data) : data.label;
            }
        };
        _this.renderV3 = function () {
            var props = _this.props;
            var defaultV3Props = {
                disabled: false,
                searchable: true,
                openMenuOnFocus: true,
                clearable: false,
                autosize: false
            };
            var DropdownIndicator = function (dropdownProps) {
                return (React.createElement(ReactSelect3Components.DropdownIndicator, __assign({}, dropdownProps), getChevronIcon(!!props.disabled)));
            };
            var IndicatorSeparator = function (_) { return null; };
            var NoOptionsMessage = function (props) {
                var noOptionStyle = { fontSize: '14px', fontWeight: 300, padding: '6px 12px', color: "" + LibColor.grey100 };
                var noResultsTextElem = typeof props.noResultsText === 'string'
                    ? React.createElement("div", { className: 'no-results-v3', style: noOptionStyle }, props.noResultsText)
                    : props.noResultsText;
                return React.createElement(ReactSelect3Components.NoOptionsMessage, __assign({}, props), noResultsTextElem);
            };
            var MultiValueRemove = function (props) {
                return React.createElement(ReactSelect3Components.MultiValueRemove, __assign({}, props),
                    React.createElement(Icon, { color: LibColor.grey70, icon: iconsMap.mediumThinX }));
            };
            var maybeMenuPortal = props.bringMenuToFront ? {
                menuPortalTarget: document.body,
            } : {};
            var optionsV3 = props.options.map(function (o) { return o.disabled ? __assign(__assign({}, o), { isDisabled: o.disabled }) : o; });
            var Option = function (optionProps) {
                return React.createElement(ReactSelect3Components.Option, __assign({}, optionProps, { className: optionProps.data.className }));
            };
            var classNamesV3 = namespacedClassnames('multi-select-v3', props.className);
            var valueV3 = props.value.length ? props.value.map(function (val) { return (val === null || val === void 0 ? void 0 : val.value) !== undefined ?
                val : props.options.find(function (option) { return option.value === val; }); }) : null;
            return (React.createElement(ReactSelect3, __assign({}, props, defaultV3Props, maybeMenuPortal, { isMulti: true, value: valueV3, options: optionsV3, onChange: _this.onChange, placeholder: props.placeholder, isDisabled: !!props.disabled, classNamePrefix: 'select-v3', className: classNamesV3, isClearable: false, components: { Option: Option, Menu: V3Menu, MultiValueRemove: MultiValueRemove, NoOptionsMessage: NoOptionsMessage, IndicatorSeparator: IndicatorSeparator, DropdownIndicator: DropdownIndicator }, styles: selectV3Styles('normal', _this.props.menuPlacement, true), 
                // blurInputOnSelect={true} - DONT PASS THIS as it conflicts with openMenuOnFocus
                onMenuOpen: props.onOpen, onMenuClose: props.onClose, onInputChange: _this.onInputChange, formatOptionLabel: _this.formatOptionLabel, menuPlacement: props.menuPlacement, menuShouldScrollIntoView: true, maxMenuHeight: 172, filterOption: _this.props.disableOptionFiltering ? function () { return true; } : undefined })));
        };
        return _this;
    }
    DeprecatedMultiSelect.prototype.render = function () {
        var prefixed = !!this.props.prefix;
        var inline = !!this.props.inline;
        var classNamesWrapper = namespacedClassnames({ 'multi-select-wrapper': prefixed });
        var prefixClassName = 'multi-select-prefix';
        var classNames = namespacedClassnames('multi-select', { prefixed: prefixed, inline: inline }, this.props.className);
        var props = __assign(__assign({}, this.props), { loadOptions: this.fakeLoadOptions, className: classNames, clearable: false, openOnFocus: true, multi: true, backspaceToRemoveMessage: '', inputProps: {
                onPaste: this.props.onPaste
            }, 
            // This is needed when options are loaded async (like user search)
            // https://github.com/JedWatson/react-select/issues/761
            filterOption: this.props.disableOptionFiltering ? function () { return true; } : undefined });
        var noResultsText = props.noResultsClickResetsInput ?
            React.createElement("div", { onClick: this.clearInput }, props.noResultsText)
            : props.noResultsText || 'No results found';
        var options = this.createOptions();
        var additionalInputResetProps = props.overrideResetOnSelect ? {
            onSelectResetsInput: false,
            ref: this.setCreatableSelectElem,
            onChange: this.onChange,
        } : {};
        var multiSelect = this.props.allowCreate
            ? (React.createElement(ReactSelectCreatable, __assign({}, props, { options: options, onChange: this.onChange, promptTextCreator: this.promptTextCreator, isValidNewOption: this.isValidNewOption, onSelectResetsInput: false, onBlurResetsInput: false, closeOnSelect: !!this.props.closeOnSelect, ref: this.setCreatableSelectElem, onNewOptionClick: this.onCreateNewOption, noResultsText: noResultsText }))) : this.props.isV3 || isFeatureEnabled('MultiSelectV3') ? this.renderV3() : (React.createElement(ReactSelectAsync, __assign({}, props, additionalInputResetProps, { options: options, noResultsText: noResultsText, cache: false })));
        var prefixText = prefixed
            ? React.createElement(Text, { className: prefixClassName, type: 'tl', color: 't30' }, this.props.prefix)
            : null;
        return prefixed
            ? (React.createElement("div", { className: classNamesWrapper },
                prefixText,
                multiSelect))
            : multiSelect;
    };
    return DeprecatedMultiSelect;
}(React.Component));
export { DeprecatedMultiSelect };
//# sourceMappingURL=multi-select.js.map